// Generated sandbox code: SSVMN - PlusTools - Editor v - 30/07/2020
// Created/Updated by Developer - 11/13/2020

import { Component } from '@angular/core'
import { CtInputDateComponent, CtInputFileComponent, HttpService, AuthService, ServicePlus, Condition, CtDialogComponent, PlusAlertsService } from 'components';
import { BaseController } from './base.controller';

@Component({
  selector: 'ac-vi01',
  template: `<div [id]="getId()" #target><div>`
})

export class AcVi01 extends BaseController {

  private dialog: CtDialogComponent;

  constructor(private authService: AuthService) {
    super();
    this.setViewCode('AC_VI01');
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  creContacts(evt) {
    let newData = this.utilService.getAdnFromAnyComponent(evt.actionParams[0]);
    let type = this.utilService.getEventUtilParam(evt, 'type', 'constant');

    if (evt.confirmField && evt.confirmValue) {
      newData.addAttribute(evt.confirmField, evt.confirmValue);
    }

    newData.addAttribute('TIP_LOCALIZACION', type ? type : 'E');

    if (newData) {
      return this.httpService.post(HttpService.ENDPOINT + '/api/SigmaApps/CL/Serv/Contacts', newData)
    }

    return false;
  }

  retContacts(evt) {
    let type = this.utilService.getEventUtilParam(evt, 'type', 'constant');
    return this.httpService.get(`${HttpService.ENDPOINT}/api/SigmaApps/CL/Serv/Contacts/${type}`)
  }

  updContacts(evt) {
    let newData = this.utilService.getAdnFromAnyComponent(evt.actionParams[0]);
    let type = this.utilService.getEventUtilParam(evt, 'type', 'constant');

    if (evt.confirmField && evt.confirmValue) {
      newData.addAttribute(evt.confirmField, evt.confirmValue);
    }

    newData.addAttribute('TIP_LOCALIZACION', type ? type : 'E');

    if (newData) {
      let numItem = this.utilService.getStringAttribute('NUM_ITEM', newData.ArrayEntities.List);
      return this.httpService.put(HttpService.ENDPOINT + '/api/SigmaApps/CL/Serv/Contacts/' + numItem, newData)
    }

    return false;
  }

  delContacts(evt) {
    let frmList = this.utilService.getComponentRef(evt.actionParams[0]);
    let adn = frmList.getSelectedFormBindingAdn();

    if (adn) {
      let numItem = this.utilService.getStringAttribute('NUM_ITEM', adn.ArrayEntities.List);
      return this.httpService.delete(HttpService.ENDPOINT + '/api/SigmaApps/CL/Serv/Contacts/' + numItem);
    }

    return false;
  }

  checkActionButtons(evt) {
    const frmList = this.utilService.getComponentRef(evt.actionParams[0]);
    const childs = frmList.getChildElements();
    for (let index = 0; index < childs.length; index++) {

			const adn = childs[index].childElements[0].childElements[1].getBindingAdn();
			const header = childs[index].childElements[0].childElements[0].childElements;
			const footer = childs[index].childElements[0].childElements[2].childElements;
			const saveBtn = footer[0];
			const favBtn = footer[2];

			saveBtn.styleClass = 'mb-1'

			if(favBtn){
				favBtn.buttonColor = 'Secondary';
				favBtn.styleClass = 'mt-1'
			} 

			if (adn.getStringAttribute('IND_PRINCIPAL') == 'S' && favBtn) {
				favBtn.icon = 'fa fa-check';
				favBtn.buttonColor = 'Primary';
				favBtn.buttonText = 'Favorito';
				favBtn.disabled = true;
			} else {
				if(!favBtn) continue;
				favBtn.icon = 'fa fa-star-o';
				favBtn.buttonText = 'Marcar como favorito';
				favBtn.eventRef = 'onCheckFavorite';
			}

			if ((adn.getStringAttribute('IND_VERIFICADO') == 'S')) {
				saveBtn.buttonText = ' Guardar';
				saveBtn.eventRef = 'onGenerateOtp';
				saveBtn.icon = 'fa fa-save';
				saveBtn.buttonColor = 'Primary';
			} else {
				saveBtn.buttonText = ' Verificar';
				saveBtn.eventRef = 'onGenerateOtp';
				saveBtn.icon = 'fa fa-check';
				saveBtn.buttonColor = 'succes-check';
			}

			if ((adn.getStringAttribute('DES_LOCALIZACION').startsWith('2') || (adn.getStringAttribute('DES_LOCALIZACION').startsWith('4')))) {
				saveBtn.buttonText = ' Guardar';
				saveBtn.eventRef = 'onGenerateOtp';
				saveBtn.icon = 'fa fa-save';
				saveBtn.buttonColor = 'Primary';
				if(!favBtn) continue;
				favBtn.icon = '';
				favBtn.buttonText = '';
			}
		}
	}

  setPrimaryContact(evt) {
    let frmList = this.utilService.getComponentRef(evt.actionParams[0]);
    let adn = frmList.getSelectedFormBindingAdn();


    if (adn) {
      let numItem = this.utilService.getStringAttribute('NUM_ITEM', adn.ArrayEntities.List);
      let contact = this.utilService.getStringAttribute('DES_LOCALIZACION', adn.ArrayEntities.List);
      let typeMail = contact.includes('@');


      let resM = `Estimado(a) asociado(a), se ha actualizado su ${typeMail ? 'correo eletrónico' : 'teléfono'} favorito a: ${contact}.`;

      let req = this.httpService.post(HttpService.ENDPOINT + '/api/SigmaApps/CL/Serv/Contacts/Favorite/' + numItem, {});
      window.scrollTo(0, 0);
      return req;
    }

    return false;
  }

  requestOtp(e, r) {
    let adn = this.utilService.getAdnFromAnyComponent(e.actionParams[0])
    let contact;


    contact = adn.getStringAttribute('DES_LOCALIZACION')?.toString();

    if (!contact) {
      this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'Debe ingresar un telefono válido.',
        true, 'Aceptar', 'Cancelar');
    }

    if (contact && contact.startsWith('2') || contact.startsWith('4')) {
      e.postAction.utilParams = e.postAction.utilParams.slice(-1);
      e.postAction.utilParams[0].name = "type=T"
      return;
    }

    let ctype = this.utilService.getEventUtilParam(e, 'type', 'constant');
    ctype = ctype ? ctype : 'E';

    let type = adn.getStringAttribute('NUM_ITEM') ? 'UPD' : 'CRE';


    return this.httpService.post(HttpService.ENDPOINT + `/api/SigmaApps/CL/Serv/VerifyCustomerContact/${type}/${ctype}/${contact}`, {})
  }

  displayOTPField(e, r) {
    let comp = this.utilService.getComponentRef(e.actionParams[0]);
    let comp2 = this.utilService.getComponentRef(e.actionParams[1]);


    if (comp.ctType == 'CtFormList') {
      let panel = comp.childElements[comp.selectedPanelIndex]
      let form = panel.childElements[0].childElements[1];
      let footer = panel.childElements[0].childElements[2];

      form.childElements[1].hidden = false;

      footer.childElements[0].buttonText = ' Validar cambios';
      footer.childElements[0].eventRef = 'onSaveAction';
    } else {
      comp.hidden = false;
    }
  }

  /**
  * Procedimiento de actualizacion de edad y documento de identificacion de la persona usuaria, al final ejecuta
  * setUserBirthDate() que setea la edad nueva en el input
  * @param e - The event object.
  * @author Jcanales
  */
  setUserIdentification(e) {

    //gets form data
    let inputDate = this.utilService.getComponentRef(e.actionParams[0]);
    let inputFile: CtInputFileComponent = this.utilService.getComponentRef(e.actionParams[1]);

    //creates the api request
    let contRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "FEC_NACIMIENTO",
          "Alias": "FEC_NACIMIENTO",
          "Value": inputDate.getValue(),
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }]
      },
      "Files": [...inputFile.getProcessedFiles()]
    }

    //API request and response handling.
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE_CL/SER_UPD_SVA_DATOS_CLIENTE', contRequest)
      .subscribe({
        next: () => {
          this.plusAlertService.setCtDialogInfo('Operación completada', 'success', 'success', 'primary', 'Estimado(a) asociado(a), le informamos que su documento de identificación ha sido correctamente cargado en nuestro sistema.',
            true, 'Aceptar', 'Cancelar');
          this.setUserBirthDate(e);
        },
        error: () => {
          this.plusAlertService.setCtDialogInfo('Operación fallida', 'downloadError', 'downloadError', 'primary', 'Estimado(a) asociado(a), le informamos que hubo un error durante la carga de su documento de identificación, por favor intente nuevamente.',
            true, 'Aceptar', 'Cancelar');
        }

      });

  }

  /**
   * Pone la edad de la persona en el inputDate, cuando inicia la pantalla y despues del proceso de actualizacion
  * @param e - The event object.
  * @author Jcanales
  * 
  */
  setUserBirthDate(e) {

    let inputDate: CtInputDateComponent = this.utilService.getComponentRef(e.actionParams[0]);

    const user = this.authService.loggedUser.user.num_cliente_sigma;

    let servicePlus: ServicePlus = new ServicePlus('CLIENTE', 'RET_CLIE', 1);
    servicePlus.Conditions = new Condition();
    servicePlus.Conditions.addConditionField('NUM_CLIENTE', user);
    servicePlus.Conditions.addConditionField('DOC_IDENTIFICACION', null);
    servicePlus.Conditions.addConditionField('NOM_COMPLETO', null);

    return this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE/RET_CLIE', servicePlus).subscribe({
      next: ({ Data }) => {
        Data[0]['ArrayEntities']['List'].forEach(element => {
          if (element['Name'] === 'FEC_NACIMIENTO') {
            inputDate.setValue(element['Value']);
            console.log(element['Value']);

          }
        });
      }
    });
  }

  /* -------------------- END CONTROLLER LOGIC ----------------- */

}
